export interface ExperimentConfig {
  id: string;
  path: string;
  cookieName: string;
  triggerValue: string;
  experimentId: string;
  experimentName: string;
  variantName: string;
}

/**
 * Configuration for all experiments
 * Add new experiments here to make them available across the app
 */
export const EXPERIMENTS: ExperimentConfig[] = [
  /*
   * Add more experiments here as needed
   * {
   *   id: "women_balance_experiment",
   *   path: "/women/products/balance/",
   *   cookieName: "women_balance_experiment",
   *   triggerValue: "variant_a",
   *   experimentId: 20,
   *   experimentName: "Women's Balance Page Redesign",
   *   variantName: "variant_a",
   * },
   * {
   *   id: "checkout_flow_experiment",
   *   path: "/checkout/",
   *   cookieName: "checkout_flow_test",
   *   triggerValue: "new_flow",
   *   experimentId: 21,
   *   experimentName: "Checkout Flow Optimization",
   *   variantName: "new_flow",
   * },
   */
];
